// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"64":"fa4ea9a9","71":"a680791c","335":"a680791c","538":"079656bd","780":"a680791c","842":"a680791c","960":"bb1ff389"}[chunkId] + ".chunk.css";
};